<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex mainDiv">
          <div class="col-sm-12 col-xs-12">
            <div
              class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area"
            >
              <div>
                <h3>{{ $t('apikey_title') }}</h3>
                <h5>{{ $t('apikey_desc') }}</h5>
              </div>
              <a-button type="primary" @click="createApiKey">
                <template #icon>
                  <i class="fa-regular fa-plus"/>
                </template>
                {{ $t('apikey_create') }}
              </a-button>
            </div>
            <div class="card-body px-0 pt-0 pb-2 table-with-search">
              <div class="col-xs-12 table-info-filter">
                <div class="total-div">
                  <p>
                    {{ $t('common_total') }} <span class="number-highlight">{{ formatCommaNumber(listSize) }}</span>{{ $t('common_case') }}
                  </p>
                </div>
                <div class="search-container">
                  <a-select 
                    style="width: 150px"
                    v-model:value="rowsPerPage" 
                    @change="handleRowsPerPage"
                  >
                    <a-select-option :value="10">10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                    <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                    <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                  </a-select>
                </div>
              </div>
              <a-table class="ant-table-striped"
                        size="small"
                        :columns="columns"
                        :data-source="responseData"
                        :pagination="false"
                        v-if="responseData.length > 0"
                >
                    <template #bodyCell="{ column, record }">
                    </template>
                </a-table>
                <div class="no-result-container" v-else>
                    <i class="fa-solid fa-exclamation-triangle" />
                    <span>{{ computedNoResultMessage }} </span>
                </div>
            </div>
            <pagination 
              v-if="!$store.state.isLoading && responseData.length > 0"
              :page-info="paginationData"
              page-name="ApiKeyList"
              @change-page="paginationHandler"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertDate, oneBtnDialog, confirmDialog, convertDateTime, formatCommaNumber,  } from '../utils/utils';
import NoResult from '../views/components/NoResult.vue';
import Pagination from '@/views/components/Pagination.vue';

export default {
  name: 'ApiKeys',
  components: {
    NoResult,
    Pagination,
  },
  data() {
    return {
      // 목록 받아오는 변수
      responseData: [],
      selectedItem: '',
      calledApiTimes: 0,

      columns:[
                {
                    key: 'index', title: this.$t('itemslist_table_no'), dataIndex: 'index', align: 'center', width: "4%",
                },
                {
                    key: 'apiKey', title: this.$t('apikey_table_apikey'), dataIndex: 'apiKey', align: 'start',
                },
                {
                    key: 'username', title: this.$t('apikey_table_createdby'), dataIndex: 'username', align: 'start',
                },
                {
                    key: 'createAt', title: this.$t('apikey_table_createdat'), dataIndex: 'createAt', align: 'start',
                        customRender: ({text, record}) => {
                            return convertDate(record.createAt)
                        },
                },
                {
                    key: 'delete-button', title: this.$t('apikey_table_delete'), dataIndex: '_id', align: 'center',
                    customRender: ({text, record}) => {
                        return (
                            <a-button 
                                shape="circle" 
                                onClick={() => this.deleteApiKey(record._id)}
                                icon={<i class="fa-solid fa-trash-can"/>}
                            >
                                
                            </a-button>
                        )
                    },
                },
            ],

            listSize: 0,
            rowsPerPage: 10, 
            paginationData: {
                currentPage: 1, 
                totalPages: 0,
            },

      listSize: 0,
      rowsPerPage: 10, 
      paginationData: {
        currentPage: 1, 
        totalPages: 0,
      },
    };
  },
  computed: {
    computedNoResultMessage() {
      if(this.calledApiTimes <= 1) {
        return this.$i18n.t('noresult_api');
      } else {
        return this.$i18n.t('noresult_search');
      }
    },
  },
  async mounted() {
    const obj = {};
    obj.page = this.paginationData.currentPage;
    this.paginationHandler(obj);
  },
  methods: {
    formatCommaNumber,
    convertDate,
    convertDateTime,
    // 주요 API
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getApiList();
    },
    // 전체 API 목록 가져오기
    async getApiList() {
      const params = {};
      params.page = this.paginationData.currentPage;
      params.limit = this.rowsPerPage;
      try {
        const response = await this.$apiInstance.get(`/apikeys`, { params });
        // 요청한 페이지 넘버 곱하기 리미트를 토탈렝스에서 뺀 값이 리미트보다 작으면
        // 리미트는 그 차이만큼 요청한다
        if (response.status === 200 || response.status === 201) {
          this.calledApiTimes ++;
          if(response.data.docs) {
            this.responseData = response.data.docs;
          } else {
            this.responseData = [];
          }
          this.listSize = response.data.totalDocs;
          for (let x = 0; x <= this.responseData.length - 1; x++) {
            this.responseData[x].index =
              this.listSize - x - (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }
          this.paginationData.totalPages = response.data.totalPages;
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('apikey_load_error_title'),this.$i18n.t('apikey_load_error_content'), false);
      }
    },

    // API키 생성
    async createApiKey() {
      try {
        const response = await this.$apiInstance.post(`${process.env.VUE_APP_SERVERURL}/apikeys`);
        if (response.status === 200 || response.status === 201) {
          await oneBtnDialog(this.$i18n.t('apikey_create_done_title'), this.$i18n.t('apikey_create_done_content'), true);
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('apikey_create_error_title'),this.$i18n.t('apikey_create_error_content'), false);
      }
    },
    
    // API키 삭제
    async deleteApiKey(itemId) {
      this.selectedItem = itemId;
      try {
        const confirmResult = await confirmDialog(this.$i18n.t('apikey_delete_title'), this.$i18n.t('apikey_delete_msg'));
        if(confirmResult) {
          const response = await this.$apiInstance.delete(`/apikeys/${this.selectedItem}`);
          if (response.status === 200 || response.status === 201) {
            await oneBtnDialog(this.$i18n.t('apikey_delete_done_title'), this.$i18n.t('apikey_delete_done_content'), true);
          }
        }
      } catch (error) {
          await oneBtnDialog(this.$i18n.t('apikey_delete_error_title'), this.$i18n.t('apikey_delete_error_content'), false);
      }
    },
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getApiList();
    },
  },
};
</script>
